import { Box, Tab, Tabs } from "@mui/material";
import { ReactNode, SyntheticEvent, useMemo, useState } from "react";

import { Product } from "api/memberPortal/project/product/product.types";
import TabTable from "components/UI/Tabs/TabTable";

import ProductsInDraftTableContainer from "../ProductsInDraftTable/ProductsInDraftTable.container";
import ProductsInFinalReviewTableContainer from "../ProductsInFinalReviewTable/ProductsInFinalReviewTable.container";

interface PendingProductsTabsProps {
  setProduct: (_product: Product) => void;
  handleOpenDraft: () => void;
}

interface TabComponentItems {
  id: number;
  label: string;
  component: ReactNode;
}

const PendingProductsTabs = ({
  setProduct,
  handleOpenDraft,
}: PendingProductsTabsProps) => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (_event: SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  // TODO: potentially look into creating a reusable tab component
  const tabComponents: TabComponentItems[] = useMemo(
    () => [
      {
        id: 0,
        label: "Products In Draft",
        component: (
          <ProductsInDraftTableContainer
            handleOpenDraft={handleOpenDraft}
            setProduct={setProduct}
          />
        ),
      },
      {
        id: 1,
        label: "Products In Final Review",
        component: <ProductsInFinalReviewTableContainer />,
      },
    ],
    [handleOpenDraft, setProduct],
  );

  return (
    <Box sx={{ mb: "1em" }}>
      <Tabs value={tabValue} onChange={handleTabChange}>
        {tabComponents.map(({ label, id }) => (
          <Tab label={`${label}`} key={`tab-${id}`} />
        ))}
      </Tabs>
      {tabComponents.map(({ component, id }, index) => {
        return (
          <TabTable index={index} value={tabValue} key={`tabTable-${id}`}>
            {component}
          </TabTable>
        );
      })}
    </Box>
  );
};

export default PendingProductsTabs;
